import { TranslationMessages } from '@/commons/types'

import idCardEstonianTranslations from './et.json'

const translations: TranslationMessages = {
    et: {
        ...idCardEstonianTranslations
    }
}

export default translations
